export default {
  /**
   * 校验文件大小
   * @param val
   */
  validateFileSize (val, size = 10) {
    return val < size * 1024 * 1024;
  },

  /**
   * 校验图片类型
   * @param val
   * @returns {boolean}
   */
  validateImageType (val) {
    return val === 'image/png' || val === 'image/jpeg' || val === 'image/gif';
  },

  /**
   * 校验登录名是否合法
   * @param val
   * @returns {boolean}
   */
  validateUsername (val) {
    const reg = /^[a-zA-Z0-9_-]{2,14}$/;
    return reg.test(val);
  },

  /**
   * 校验登录密码是否合法
   * @param val
   * @returns {boolean}
  */

  validatePassword (val) {
    // const reg = /^[\w\s~!@%#$^*+='?\-\\/(){}\[\],.\|《》、，。！{}·#￥……*（）——:：“”？【】；‘’`_;\"]{9,20}$/;

    // 所有 + 特殊符号
    // const reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{6,20}$/;
    // 所有 + 特殊符号
    const reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.).{6,20}$/;
    // const reg = /(?!^\\d+$)(?!^[a-zA-Z]+$)(?!^[_#@]+$).{8,}/
    return reg.test(val);
  },

  /**
   * 校验电话是否合法（包括手机号）
   * @param val
   * @returns {boolean}
   */
  validatePhone (val) {
    const reg = /^(1\d{10}|[0-9-—]{7,20})$/;
    return reg.test(val);
  },

  /**
   * 校验手机号是否合法
   * @param {*} val
   */
  validateMobile (val) {
    const reg = /^1\d{10}$/;
    return reg.test(val);
  },

  /**
   * 校验邮箱是否合法
   * @param {*} val
   */
  validateEmail (val) {
    const reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
    return reg.test(val);
  },

  /**
   * 校验身份证号码是否合法
   * @param {*} val
   */
  validateIdCode (val) {
    const reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
    return reg.test(val);
  },

  /**
   * 校验15位身份证号码是否合法
   * @param {*} Id
   */
  checkIDCard15 (Id) {
    // let n = 0;
    if (isNaN(Id) || Number(Id) < Math.pow(10, 14)) {
      return false; // 数字验证
    }

    const address = '11x22x35x44x53x12x23x36x45x54x13x31x37x46x61x14x32x41x50x62x15x33x42x51x63x21x34x43x52x64x65x71x81x82x91';
    if (address.indexOf(Id.substr(0, 2)) === -1) {
      return false; // 省份验证
    }

    const birth = Id.substr(6, 6).replace(/^(\d{2})(\d{2})/, '$1-$2-');
    const time = new Date(birth);
    if (isNaN(time.getTime())) {
      return false; // 生日验证
    }

    return true; // 符合15位身份证标准
  },

  /**
   * 校验18位身份证号码是否合法
   * @param {*} Id
   */
  CheckIDCard18 (Id) {
    // let aaa = DESEncryptHelper.DESEncrypt(13).toString();
    // let n = 0;
    if (!parseInt(Id.substring(0, 17), 10) || parseInt(Id.substring(0, 17), 10) < Math.pow(10, 16) || !parseInt(Id.replace(/x/g, '0').replace(/X/g, '0'), 10)) {
      return false; //数字验证
    }
    let address = "11x22x35x44x53x12x23x36x45x54x13x31x37x46x61x14x32x41x50x62x15x33x42x51x63x21x34x43x52x64x65x71x81x82x91";
    if (address.indexOf(Id.substring(0, 2)) === -1) {
      return false; //省份验证
    }
    let birth = Id.substring(6, 14);
    let time = new Date(birth.slice(0, 4), birth.slice(4, 6) - 1, birth.slice(6));
    if (isNaN(time.getTime())) {
      return false; //生日验证
    }
    let arrVarifyCode = [1, 0, 'x', 9, 8, 7, 6, 5, 4, 3, 2];
    let Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    let Ai = Id.substring(0, 17).split('');
    let sum = 0;
    for (let i = 0; i < 17; i++) {
      sum += parseInt(Wi[i]) * parseInt(Ai[i]);
    }
    let y = -1;
    sum = Math.floor(sum / 11);
    y = sum - 11 * Math.floor(sum / 11);
    if (arrVarifyCode[y] != Id.substring(17, 18).toLowerCase()) {
      return false; //校验码验证
    }
    return true; //符合GB11643-1999标准
  },

  /**
   * 校验URL是否合法
   * @param {*} val
   */
  validateUrl (val) {
    const reg = /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i;
    return reg.test(val);
  },

  /**
   * 校验路由是否合法
   * @param {*} val
   */
  validateRouter (val) {
    const reg = /^\/+/;
    return reg.test(val);
  },

  /**
   * 校验金额是否合法
   * @param {*} val
   */
  validateAmount (val) {
    const reg = /^[0-9]{1,8}(\.[0-9]{1,2})?$/;
    return reg.test(val);
  },

  /**
   * 校验整数是否合法
   * @param {*} val
  */
  validateInteger (val) {
    const reg = /^-?[0-9]\d*$/;
    return reg.test(val);
  },

  /**
   * 校验浮点数是否合法
   * @param {*} val
   */
  validateFloat (val) {
    const reg = /^(-?\d+)(\.\d+)?$/;
    return reg.test(val);
  }
};
